<app-loader [Parent]="this"></app-loader>

@if (Model != null) {
  <div>
    <app-pageheader [Parent]="this">
      <form-edit-button>Edit</form-edit-button>
      <app-form-delete-button [Model]="Model" [Parent]="this" DeleteUrl="integrations/flowbird/configurations/"
        [DeleteCheck]="false"
        DeleteNavLink="/integrations/flowbird">
      </app-form-delete-button>
    </app-pageheader>
    <div class="columns is-justify-content-center">
      <div class="column is-8">
        <article class="panel">
          <p class="panel-heading">
            {{Model.Name || 'Flowbird Configuration'}}
          </p>
          <a class="panel-block">
            <span class="label">URL</span>
            <span class="value">{{Model.Url}}</span>
          </a>
          @if (Model.Description) {
            <a class="panel-block">
              <span class="label">Description</span>
              <span class="value">{{Model.Description}}</span>
            </a>
          }
          <a class="panel-block">
            <span class="label">Username</span>
            <span class="value">{{Model.Username}}</span>
          </a>
          <a class="panel-block">
            <span class="label">Import Schedule Minutes</span>
            <span class="value">{{Model.ImportScheduleMinutes}}</span>
          </a>
          @if (Model.LastRunOn) {
            <a class="panel-block">
              <span class="label">Last Run On</span>
              <span class="value">{{Model.LastRunOn | date:'medium'}}</span>
            </a>
          }
        </article>
        <article class="panel">
          <p class="panel-heading">
            Terminal Mappings
          </p>
          @if (!Model.TerminalMappings || Model.TerminalMappings.length === 0) {
            <div class="panel-block">
              <span class="has-text-grey-light">No terminal mappings configured.</span>
            </div>
          }
          @if (Model.TerminalMappings && Model.TerminalMappings.length > 0) {
            <table class="table is-fullwidth is-striped">
              <thead>
                <tr>
                  <th>Terminal ID</th>
                  <th>Parking Lot External ID</th>
                </tr>
              </thead>
              <tbody>
                @for (mapping of Model.TerminalMappings; track mapping) {
                  <tr>
                    <td>{{mapping.TerminalId}}</td>
                    <td>{{mapping.ParkingLotExternalId}}</td>
                  </tr>
                }
              </tbody>
            </table>
          }
        </article>
      </div>
    </div>
  </div>
}

